import gsap from 'gsap';

class LanguageSwitcher {
    toggleBtn: HTMLElement;
    listbox: HTMLElement;
    options: HTMLElement[];
    currentIndex: number;

    constructor(languageSwitcher: HTMLElement) {
        const scope = gsap.utils.selector(languageSwitcher);

        const [toggleBtn] = scope('#language-toggle');
        const [listBox] = scope('#language-list');
        this.options = Array.from(listBox.querySelectorAll('[role=option]'));
        this.currentIndex = -1;

        this.toggleBtn = toggleBtn;
        this.listbox = listBox;

        this.init();
    }

    init() {
        this.toggleBtn.addEventListener('click', () => {
            const expanded =
                this.toggleBtn.getAttribute('aria-expanded') === 'true';
            expanded ? this.closeListbox() : this.openListbox();
        });

        this.toggleBtn.addEventListener('mouseenter', () => {
            this.openListbox();
        });

        this.toggleBtn.addEventListener('keydown', (e) =>
            this.onToggleKeydown(e)
        );
        this.listbox.addEventListener('keydown', (e) =>
            this.onListboxKeydown(e)
        );

        document.addEventListener('click', (e: MouseEvent) => {
            if (
                !this.toggleBtn.contains(e.target as Node) &&
                !this.listbox.contains(e.target as Node)
            ) {
                this.closeListbox();
            }
        });
    }

    openListbox() {
        this.listbox.classList.remove('hidden');
        this.toggleBtn.setAttribute('aria-expanded', 'true');
        this.listbox.focus();
    }

    closeListbox() {
        this.listbox.classList.add('hidden');
        this.toggleBtn.setAttribute('aria-expanded', 'false');
        this.currentIndex = -1;
    }

    onToggleKeydown(e: KeyboardEvent) {
        if (['ArrowDown', 'Enter', ' '].includes(e.key)) {
            e.preventDefault();
            this.openListbox();
            this.currentIndex = 0;
            this.options[this.currentIndex].focus();
        }
    }

    onListboxKeydown(e: KeyboardEvent) {
        if (e.key === 'Escape') {
            e.preventDefault();
            this.closeListbox();
            this.toggleBtn.focus();
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            this.currentIndex = (this.currentIndex + 1) % this.options.length;
            this.options[this.currentIndex].focus();
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            this.currentIndex =
                (this.currentIndex - 1 + this.options.length) %
                this.options.length;
            this.options[this.currentIndex].focus();
        }
    }
}

export default {
    init() {
        const languageSwitcherElement =
            document.querySelectorAll('.language-switcher');

        if (languageSwitcherElement.length === 0) {
            return;
        }
        languageSwitcherElement.forEach((element) => {
            new LanguageSwitcher(element as HTMLElement);
        });
    }
};
